import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

export const COLUMNS = 5;

export default createUseStyles(
  {
    root: {
      textAlign: 'center',
    },

    grid: {
      columnCount: COLUMNS,
      columnGap: Spacings.s24,

      '@media screen and (max-width: 1112px)': {
        columnCount: 4,
      },

      '@media screen and (max-width: 780px)': {
        columnCount: 3,
      },

      '@media screen and (max-width: 480px)': {
        columnCount: 2,
      },
    },

    skeletonTemplate: {
      height: 180,
    },

    skeletonTitle: {
      height: 36,
      marginBottom: Spacings.s12,
    },

    skeletonDescription: {
      height: 72,
      marginBottom: Spacings.s24,
    },

    template: {
      marginBottom: Spacings.s24,
      borderRadius: Spacings.s8,
      '& img': {
        borderRadius: Spacings.s8,
      },
    },

    buttonContainer: {
      paddingTop: Spacings.s48,
    },
  },
  { name: 'ColorTemplates' },
);
